import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { fetchWebshops, WebshopActions } from '@store/actions/webshop.actions';
import { CompanyActions } from '@store/actions/company.actions';
import { WebshopService } from '@modules/shared/services/webshop.service';

@Injectable()
export class WebshopEffects {
  private readonly actions$ = inject(Actions);
  private readonly webshopService = inject(WebshopService);

  getWebshops$ = createEffect(() => this.actions$.pipe(
    ofType(WebshopActions.GET_WEBSHOPS),
      exhaustMap(() => this.webshopService.getAll()
        .pipe(
          map(payload => ({ type: WebshopActions.GET_WEBSHOPS_SUCCESS, payload })),
          catchError(error => of(({ type: WebshopActions.GET_WEBSHOPS_FAILED, error }))),
        )),
    ),
  );

  getWebshop$ = createEffect(() => this.actions$.pipe(
      ofType(WebshopActions.GET_WEBSHOP),
      exhaustMap((action: any) => this.webshopService.get(action.payload)
        .pipe(
          map(payload => ({type: WebshopActions.GET_WEBSHOP_SUCCESS, payload})),
          catchError(error => of(({type: WebshopActions.GET_WEBSHOP_FAILED, error}))),
        )),
    ),
  );

  updateWebshop$ = createEffect(() => this.actions$.pipe(
      ofType(WebshopActions.UPDATE_WEBSHOP),
    exhaustMap(({payload}: any) => {
      return this.webshopService.update(payload)
        .pipe(
          map(payload => ({type: WebshopActions.UPDATE_WEBSHOP_SUCCESS, payload})),
          catchError(error => of(({type: WebshopActions.UPDATE_WEBSHOP_FAILED, error}))),
        )
    }),
    ),
  );

  createWebshop$ = createEffect(() => this.actions$.pipe(
      ofType(WebshopActions.CREATE_WEBSHOP),
      exhaustMap((action: any) => this.webshopService.create(action.payload)
        .pipe(
          map(payload => ({type: WebshopActions.CREATE_WEBSHOP_SUCCESS, payload})),
          catchError(error => of(({type: WebshopActions.CREATE_WEBSHOP_FAILED, error}))),
        )),
    ),
  );

  deleteWebshop$ = createEffect(() => this.actions$.pipe(
      ofType(WebshopActions.DELETE_WEBSHOP),
      exhaustMap((action: any) => this.webshopService.delete(action.payload)
        .pipe(
          map(payload => ({type: WebshopActions.DELETE_WEBSHOP_SUCCESS, payload})),
          catchError(error => of(({type: WebshopActions.DELETE_WEBSHOP_FAILED, error}))),
        )),
    ),
  );

  onCompanySelected$ = createEffect(() => this.actions$.pipe(
    ofType(CompanyActions.SELECT_COMPANY),
    map(() => fetchWebshops())
  ));
}
